import { useQuery } from '@tanstack/react-query';
import type { GlobalSearchResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

export function useGlobalSearch(q: string) {
  return useQuery({
    queryKey: ['search', q],
    queryFn: () => api.get<GlobalSearchResponse>(`/search?q=${encodeURIComponent(q)}`),
    enabled: q.trim().length > 0,
  });
}
